/** The short label a sidebar or badge shows for an endpoint's method, or EVENT for a webhook. */
export function apiMethodLabel(method: string, kind: "endpoint" | "webhook") {
	if (kind === "webhook") return "EVENT"
	return method === "delete" ? "DEL" : method.toUpperCase()
}
